import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/traderesponses`;

export default {
 
  getTradeRequestsResponseList(baseURL = {}, headers = {}, params = {}, paramsSerializer){
    return BaseRepository.get(`${resource}/by-trade-request-owner`, {
        baseURL,
        headers,
        params,
        paramsSerializer,
    });
  },
  getAllResponsesPerItem(baseURL = {}, headers = {}, params = {}){
    return BaseRepository.get(`${resource}/items`, {
      baseURL,
      headers,
      params,
      
  });
  },
  getDocuments(id,baseURL = {}, headers = {}, params = {}){
    return BaseRepository.get(`${resource}/${id}/item/documents`, {
      baseURL,
      headers,
      params,
      
  });
  },
  accept(id, body, baseURL = {}, headers = {}, params = {}){
    return BaseRepository.post(`${resource}/${id}/accept`,body, {
      baseURL,
      headers,
      params,
      
  });
  },
  reject(id, body, baseURL = {}, headers = {}, params = {}){
    return BaseRepository.post(`${resource}/${id}/reject`,body, {
      baseURL,
      headers,
      params,
      
  });
  },
  assign(id, body, baseURL = {}, headers = {}, params = {}){
    return BaseRepository.post(`${resource}/${id}/assign`,body, {
      baseURL,
      headers,
      params,
      
  });
  },
  getPrice(id, baseURL = {}, headers = {}, params = {}){
    return BaseRepository.get(`${resource}/${id}/item/price`, {
      baseURL,
      headers,
      params,
      
  });
  },
}